<template>
  <div class="footer-submit">
    <div class="submit-bg">
      <div class="footer-left">
        <div class="footer-title">
          预约试驾
        </div>
        <div class="submit-img-wrap">
          <div class="img-items">
            <!-- <img class="submit-img img-position" src="../assets/home/icon_home_footer_01.png" /> -->
            <!-- <img class="submit-img img-position" src="../assets/home/icon_home_footer_02.png" /> -->
            <div class="imgs">
              <img class="submit-img img-seat" src="../assets/home/icon_home_footer_01.png" />
              <img class="submit-img img-position" src="../assets/home/icon_home_footer_02.png" />
            </div>
            <div class="img-infos">
              探所
              <span>平行时空</span>
            </div>
          </div>
          <div class="img-items">
            <!-- <div class="imgs">
              <img class="submit-img img-seat" src="../assets/home/icon_home_footer_01.png" />
            </div> -->
            <img class="submit-img" src="../assets/home/icon_home_footer_01.png" />
            <div class="img-infos">
              探所
              <span>2049</span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-right">
        <span class="submit-title">预约体验</span>
        <!-- <div class="submit-items">
          <span class="submit-label">体验车型：</span>
          <el-input class="submit-input" size="small" placeholder="探所2049" />
        </div>
        <div class="submit-items">
          <span class="submit-label">体验地点：</span>
          <el-input class="submit-input" size="small" placeholder="深圳探所壹方城体验中心" />
        </div>
        <div class="submit-items">
          <span class="submit-label">手机号码：</span>
          <el-input class="submit-input" size="small" placeholder="请输入手机号码" />
        </div>
        <div class="submit-items">
          <span class="submit-label">验证码：</span>
          <el-input class="submit-input" size="small" placeholder="请输入验证码" />
          <span class="submit-send">获取验证码</span>
        </div> -->
        <div class="submit-items">
          <span class="submit-label">姓名：</span>
          <el-input class="submit-input" v-model="user_name" size="small" placeholder="请输入姓名" />
        </div>
        <div class="submit-items">
          <span class="submit-label">手机号码：</span>
          <el-input class="submit-input" v-model="mobile" size="small" placeholder="请输入手机号码" />
        </div>
        <div class="submit-items">
          <span class="submit-label">验证码：</span>
          <el-input class="submit-input" v-model="sms_code" size="small" placeholder="请输入验证码" />
          <span class="submit-send" :class="{ 'btn-check': isMobiel }" v-if="isSend" @click="sendCode">发送验证码</span>
          <span class="submit-send btn-check" v-if="timeSecond > 0 && !isSend">{{ timeSecond }}s</span>
        </div>
        <div class="submit-items">
          <span class="submit-label">体验地点：</span>
          <!-- <el-input class="submit-input" v-model="adress_name" size="small" placeholder="请选择地区" /> -->
          <el-cascader
            class="submit-input"
            v-model="adress_name"
            size="small"
            placeholder="请选择地区"
            :props="cascaderOption"
            :options="addressOptions"
          ></el-cascader>
        </div>
        <div class="submit-items">
          <span class="submit-label">体验车型：</span>
          <el-select class="submit-input" size="small" v-model="bike_model">
            <el-option
              v-for="item in bikeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="submit-items">
          <span class="submit-label submit-label2">主要想体验<br />TASOW 的哪些方面：</span>
          <!-- <el-input class="submit-input" v-model="experience" size="small" placeholder="" /> -->
          <el-select class="submit-input" v-model="experience" multiple size="small" placeholder="">
            <el-option
              v-for="item in columnsDomain"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="submit-trips">
          我们的产品专家将尽快与您确认具体体验时间，请您留意接听。
        </div>
        <div class="submit-check">
          <span class="confirm-icon" :class="{ 'is-agree': isAgree }" @click="updateAgree">
            <i></i>
          </span>
          <span class="confirm-txt">我已阅读并同意</span>
          <!-- <span class="confirm-term">《预约服务隐私政策》</span> -->
          <span class="confirm-term" @click="linkPath('privacy.html')">《隐私政策》</span>
          <span class="confirm-term" @click="linkPath('securityNotice.html')">《试驾安全须知》</span>
        </div>
        <div class="confirm-btn" :class="{ 'btn-submit': isSubmit }" @click="submitInfo">
          立即预约
        </div>
      </div>
    </div>

    <!-- <div class="home-seat-footer">
      <span class="version" @click="openPath('privacy.html')">隐私政策</span>
      <span class="version" @click="openPathbak()">沪ICP备2024096717号</span>
    </div> -->
  </div>
</template>

<script>
import { areaList, useCascaderAreaData } from '@vant/area-data';
import axios from 'axios';
import { filingsUrl, httpUrl } from '../constant.js';

export default {
  data() {
    return {
      isAgree: false,
      addressOptions: [],
      user_name: '',
      mobile: '',
      sms_code: '',
      // ---
      adress_name: '',
      province_name: '',
      province_code: '',
      city_name: '',
      city_code: '',
      district_name: '',
      district_code: '',
      bike_model: null,
      // ---
      experience: '',
      columnsDomain: ['驾驶感受', '实车品质', '功能配置', '续航/动能', '服务体验'],
      cascaderOption: { label: 'text' },
      bikeList: [
        { value: 1, label: '探所2049' },
        { value: 2, label: '探所平行时空' }
      ],
      isSend: true,
      timeSecond: 60,
      timer: null
    }
  },
  computed: {
    isSubmit() {
      return this.user_name && this.mobile && this.sms_code && this.adress_name && this.bike_model && this.isAgree;
    },
    isMobiel() {
      return this.mobile && /^1(3|4|5|6|7|8|9)\d{9}$/.test(this.mobile);
    },
  },
  mounted() {
    // addressOptions
    this.addressOptions = useCascaderAreaData();

    navigator.geolocation.getCurrentPosition(function(position) {
        console.log("Latitude: " + position.coords.latitude);
        console.log("Longitude: " + position.coords.longitude);
    }, function(error) {
        console.error("Error Code = " + error.code + " - " + error.message);
    });
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    openPathbak() {
      window.open(filingsUrl, '_blank');
    },
    // initData() {
    //   const { province_list, county_list, city_list } = areaList;
    //   // addressOptions
    //   Object.entries(province_list).forEach(([value, label]) => {
    //     const province = {
    //       label,
    //       value,
    //       children: [],
    //     };
    //
    //     Object.entries(city_list).forEach(([v, l]) => {
    //       const city = {
    //         label: l,
    //         value: v,
    //         children: []
    //       }
    //       Object.entries(county_list).forEach(([vv, ll]) => {
    //         if (vv.slice(0, 4) === v.slice(0, 4)) {
    //           city.children.push({
    //             label: ll,
    //             value: vv,
    //           })
    //         }
    //       });
    //
    //       if (value.slice(0, 2) === v.slice(0, 2)) {
    //         province.children.push(city)
    //       }
    //     })
    //
    //     this.addressOptions.push(province)
    //   });
    // },
    linkPath(path) {
      window.open(path, '_blank');
    },
    updateAgree() {
      this.isAgree = !this.isAgree;
    },
    checkMobile() {
      let status = false;
      if (this.mobile) {
        status = /^1(3|4|5|6|7|8|9)\d{9}$/.test(this.mobile);
        if (!status) {
          this.$message({ type: 'warning', message: '手机号格式错误' });
        }
      } else {
        this.$message.warning('请输入手机号');
      }

      return status;
    },
    checkName() {
      let status = true;
      if (this.user_name) {
        status = /^[0-9a-zA-Z\u4e00-\u9fa5]{1,8}$/.test(this.user_name);
        if (!status) {
          this.$message({ type: 'warning', message: '格式错误' });
        }
      }

      return status;
    },
    sendCode() {
      if (!this.checkMobile()) return;
      const data = {
        params: {
          phone_number: this.mobile
        }
      }
      axios.post(`${httpUrl}/beta/customer/sendSms`, data)
        .then(({ data }) => {
          if (data.code === 0) {
            this.$message({ type: 'success', message: '验证码发送成功' });
            this.isSend = false;
            this.timeSecond = 60;
            this.timer = setInterval(() => {
              this.timeSecond -= 1;

              if (this.timeSecond < 1) {
                clearInterval(this.timer);
                this.isSend = true;
              }
            }, 1000);
          } else if (data.code === 30011) {
            this.$message({ type: 'warning', message: '您已预约过试驾，我们的销售顾问会尽快与您取得联系' });
          } else {
            this.$message({ type: 'warning', message: data.message || '您已注册 请勿重复提交' });
          }
        }).catch(() => {
            this.$message({ type: 'warning', message: '发送失败' });
        })
    },
    submitInfo() {
      if (!this.checkName() || !this.checkMobile()) return;

      if (!this.user_name) {
        this.$message({ type: 'warning', message: '请输入姓名' });
      } else if (!this.mobile) {
        this.$message({ type: 'warning', message: '请输入手机号' });
      } else if (!this.sms_code) {
        this.$message({ type: 'warning', message: '请输入手机号验证码' });
      } else if (!this.adress_name) {
        this.$message({ type: 'warning', message: '请选择地区' });
      } else if (!this.isAgree) {
        this.$message({ type: 'warning', message: '请勾选隐私政策' });
      } else if (!this.bike_model) {
        this.$message({ type: 'warning', message: '请选择体验车型' });
      } else {
        const { province_list, county_list, city_list } = areaList;
        const [province_code, city_code, district_code] = this.adress_name;
        const province_name = province_list[province_code];
        // const province_code = province_code;
        const city_name = city_list[city_code];
        const district_name = county_list[district_code];

        const data = {
          params: {
            user_name: this.user_name,
            mobile: this.mobile,
            sms_code: this.sms_code,
            bike_model: this.bike_model,
            province_name,
            province_code,
            city_name,
            city_code,
            district_name,
            district_code,
          }
        };

        if (this.experience && this.experience.length > 0) {
          const arr = [];
          this.experience.forEach((item) => {
            const index = this.columnsDomain.findIndex(i => item === i);
            arr.push(index + 1);
          })

          data.params.taste_code = arr.sort().join();
        }

        axios.post(`${httpUrl}/beta/customer/add/customer`, data)
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message({ type: 'success', message: '预约成功' });
              this.user_name = '';
              this.mobile = '';
              this.sms_code = '';
              this.adress_name = '';
              this.experience = '';
            } else {
              this.$message({ type: 'warning', message: data.message || '提交失败，请稍后重试' });
            }
          }).catch(() => {
              this.$message({ type: 'warning', message: '发送失败' });
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.footer-submit {
  background-image: linear-gradient(0deg, rgba(255,255,255,0.10) 0%, #FFF1E1 100%);
  .submit-bg {
    width: 100%;
    padding: 60px 11% 0 2%;
    padding-bottom: 40px;
    box-sizing: border-box;
    display: flex;
    // background: url('../assets/icon_reservation_submit_bg.png') no-repeat center;
    // background-size: 100%;
  }
  box-sizing: border-box;
  .footer-left {
    flex: 1;
    // padding-right: 100px;
    .footer-title {
      display: block;
      font-size: 32px;
      color: #222222;
      text-align: center;
      font-weight: 400;
      padding: 50px 0;
      letter-spacing: 10px;
    }
    .submit-img-wrap {
      display: flex;
      padding-top: 7%;
      .img-items {
        flex: 1;
        padding: 0 20px;
        .imgs {
          position: relative;
          .img-position {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 90%;
            margin-left: -46%;
            transform: translateY(-48%);
          }
          .img-seat {
            opacity: 0;
          }
        }
        .submit-img {
          width: 100%;
        }
        .img-infos {
          padding: 20px 0;
          text-align: center;
          font-size: 20px;
          color: #222222;
          letter-spacing: 1px;
          span {
            font-weight: 500;
          }
        }
      }
    }
  }
  .footer-right {
    flex: 0 0 350px;
    width: 350px;
    // width: 440px;
    padding: 24px 40px;
    background: #fff;
    border-radius: 10px;
    // box-sizing: border-box;
    .submit-title {
      line-height: 50px;
      font-size: 25px;
      color: #000000;
      font-family: 'PingFangSC-Regular';
    }
    .submit-items {
      display: flex;
      border-bottom: 1px solid #D5D5D5;
      padding: 8px 0 4px 0;
      .submit-label {
        width: 90px;
        line-height: 32px;
        color: #000000;
        font-size: 16px;
        font-weight: 500;
      }
      .submit-label2 {
        width: 160px;
        line-height: 22px;
      }
      .submit-input {
        flex: 1;
        /deep/.el-input__inner {
          border: none;
        }
      }
      .submit-send {
        width: 100px;
        line-height: 32px;
        font-size: 15px;
        background: #000000;
        border-radius: 45px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        opacity: 0.4;
        &.btn-check {
          opacity: 1;
        }
      }
    }
    .submit-trips {
      padding-top: 10px;
      font-size: 18px;
      color: #919191;
      letter-spacing: 1px;
      line-height: 32px;
    }
    .submit-check {
      display: flex;
      padding: 20px 0 40px 0;
      margin-right: -10px;
      cursor: pointer;
      .confirm-icon {
        width: 12px;
        height: 12px;
        background: rgba(123,130,141,0.20);
        border: 1px solid rgba(123,130,141,0.70);
        border-radius: 12px;
      }
      .is-agree {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #426BF2;
        i {
          display: block;
          width: 8px;
          height: 8px;
          background: #426BF2;
          border-radius: 50%;
        }
      }
      .confirm-txt {
        padding-left: 12px;
        font-family: 'PingFangSC-Regular';
        font-size: 15px;
        color: #2C2D2E;
      }
      .confirm-term {
        font-family: 'PingFangSC-Regular';
        font-size: 15px;
        color: #426BF2;
      }
    }
    .confirm-btn {
      background: #000000;
      border-radius: 45px;
      line-height: 45px;
      font-family: 'PingFangSC-Regular';
      font-size: 19px;
      color: #FFFFFF;
      text-align: center;
      cursor: pointer;
      opacity: 0.4;
      &.btn-submit {
        opacity: 1;
      }
    }
  }

  .home-seat-footer {
    position: relative;
    z-index: 9;
    width: 100%;
    padding: 0 11%;
    box-sizing: border-box;
    height: 46px;
    line-height: 46px;
    background: #222222;
    margin-top: -4px;
    text-align: left;
    color: #fff;
    font-size: 14px;
    text-align: center;
    .version {
      padding: 0 12px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
@media (min-width: 1700px) {
  .footer-submit {
    .submit-bg {
      background-size: 80%;
    }
  }
}
</style>
